<template>
    <vs-popup classContent="popup-example" :title="translate('NewTicket')" :active.sync="popUps.popupAddActive">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">          
          <vs-input label="Subject" class="inputx w-full" v-model="params.subject" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">          
          <vs-textarea class="inputx w-full" label="Message" v-model="params.message" ></vs-textarea>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select Priority"
              autocomplete
              class="selectExample inputx w-full"
              label="Priority"
              v-model="params.priority"
              >
              <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in priorities" />
          </vs-select>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select Department"
              autocomplete
              class="selectExample inputx w-full"
              label="Department"
              v-model="params.department"
              @change="getSubDepartments"
              >
              <vs-select-item :key="index" :value="item.dep_name" :text="item.dep_name" v-for="(item,index) in $store.state.departments" />
          </vs-select>
        </div>
      </div>
    <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select Sub Department"
              autocomplete
              class="selectExample inputx w-full"
              label="Sub Department"
              v-model="params.subDepartment"
              >
              <vs-select-item :key="index" :value="item.dep_name" :text="item.dep_name" v-for="(item,index) in subDepartments" />
          </vs-select>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="saveData()" color="primary" type="filled">{{translate('Save')}}</vs-button>
        </div>
      </div>
    </vs-popup>
</template>
<script>
import axios from "@/axios.js"
export default {
    props:['popUps','componentKey'],
    data() {
        return {
            priorities:['high','low','medium'],
            params:{subject:'',message:'',newTicket:'true',subDepartment:null,department:null,priority:null},
            subDepartments:[]
        }
    },
    methods:{
      getSubDepartments: function(){
        console.log('hi')
        this.$vs.loading();
        let that = this;

        axios.get("/api/tickets?department="+this.params.department)
        .then((data) => {
          that.$vs.loading.close();  
          that.subDepartments.splice(0);
            for(let i in data.data){
              const obj = JSON.parse(data.data[i].object);
              that.subDepartments.push(obj);
            }                            
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
      },
      translate: function(key){
        return this.$t(key);
      },
      openAlert(color,title,text) {
        let colorAlert = color;
        this.$vs.notify({
            title: title,
            text: text,
            color: colorAlert
        })
      },
      saveData() {
        this.$vs.loading();
        let that = this;
        axios.post("/api/tickets",this.params)
        .then((data) => {
          that.$vs.loading.close();
          if(data.data.success){
            that.openAlert('success','Success');
            that.componentKey++;
            that.popUps.popupAddActive = false;
            that.$router.go()
          } else{
            that.openAlert('danger','Failed',data.data.messsage);
          }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })      
      },
    }
}
</script>